import * as constants from "./../constants";
import { getAvatarStringFromName, getLedgerDisplayDateTime, getDateInStringDDMMMYYYY, getVehicleNumberValuesDWeb } from "./utils/utils";
import { getDateStringDDMMM } from "../../utils/utils";
import * as logger from './../../logger';
import { element } from "prop-types";

/**
 * Party Ledger screen
 * @param {*} data - API Request data
 * @param {*} onSuccess
 * @param {*} onError
 */
export const getPartiesWithBalance = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/customers/balance",
    data,
    success: (response) => populateNoStateUpdate(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const getTripDetailsSimplified = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/trip/${data.id}/${data.type}/basic`,
    data,
    success: (response) => populateNoStateUpdate(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
})

export const getSuppliersWithBalance = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/vendors/balance",
    data,
    success: (response) => populateNoStateUpdate(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const getPartiesTrips = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/trip/filters/apply",
    data,
    success: (response) => populateNoStateUpdate(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
const populateNoStateUpdate = (response) => {
  return { type: null, payload: null };
}
export const getPartyLedgerDataOld = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/fetchcustomertransaction-v2",
    data,
    success: (response) => populatePartyLedgerData(response, data && data.merge ? data.merge : false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getPartyLedgerData = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/customer/ledger",
    data,
    success: (response) => populatePartyLedgerData(response, data && data.merge ? data.merge : false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const populatePartyLedgerData = (response, merge) => {
  var homeScreenData = {}
  var partyLedgerData = []
  if (response.status && response.status.code && response.status.code == 200) {
    if (response.response) {
      homeScreenData.activeTripCount = response.response.totalActiveTripsCount ? response.response.totalActiveTripsCount : 0
      homeScreenData.vendorBalance = response.response.vendorBalance ? response.response.vendorBalance : 0
      homeScreenData.partyBalance = parseInt(response.response.totalNotYetDueAmount ? response.response.totalNotYetDueAmount : 0)
      homeScreenData.partyBalance += parseInt(response.response.totalDueAmount ? response.response.totalDueAmount : 0)

      let partyLedgerDataResponse = response.response.customerLogs
      if (partyLedgerDataResponse.length > 0)
        for (var i = 0; i < partyLedgerDataResponse.length; i++) {
          partyLedgerData.push({
            ... partyLedgerDataResponse[i],
            id: partyLedgerDataResponse[i].id,
            contactNumber: partyLedgerDataResponse[i].contactNumber,
            customerId: partyLedgerDataResponse[i].customerId,
            partyName: partyLedgerDataResponse[i].name,
            activeTripsCount: partyLedgerDataResponse[i].activeTripsCount,
            lastUpdated: getLedgerDisplayDateTime(partyLedgerDataResponse[i].updatedAt),
            partyBalance: parseFloat(partyLedgerDataResponse[i].notYetDueAoumt) +
              parseFloat(partyLedgerDataResponse[i].dueAmount),
            avatarString: getAvatarStringFromName(partyLedgerDataResponse[i].name),
            partyBalance:partyLedgerDataResponse[i].partyBalance
          })
        }
    } else {
      console.error("Error while fetching party ledger data : " + response.status.code + " : " + response.status.message)
    }
    homeScreenData.partyLedgerData = partyLedgerData;
  }
  return {
    type: constants.GET_PARTY_LEDGER_DATA, payload: {
      homeScreenData,
      totalCount:
        response.response.totalCount,
      maxPage: response.response.maxPage,
      merge: merge
    }
  };
}

/**
 * Supplier Ledger Screen
 * @param {*} data - API Request data
 * @param {*} onSuccess
 * @param {*} onError
 */
export const getVendorLedgerData = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/fetch_vendor_ledger-v2",
    data,
    success: (response) => populateVendorLedgerData(response, data && data.merge ? data.merge : false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const populateVendorLedgerData = (response, merge) => {
  var vendorLedgerData = []
  if (response.status && response.status.code && response.status.code == 200) {
    if (response.response) {
      let vendorLedger = {
        activeTripCountDweb: response.response.activeTripCount,
        totalRemainingAmountDweb: response.response.totalRemainingAmount
      }
      let vendorLedgerDataResponse = response.response.vendors
      if (vendorLedgerDataResponse.length > 0) {
        for (var i = 0; i < vendorLedgerDataResponse.length; i++) {
          vendorLedgerData.push({
            id: vendorLedgerDataResponse[i].id,
            vendorName: vendorLedgerDataResponse[i].name,
            vendorNumber: vendorLedgerDataResponse[i].vendorNumber,
            activeTripsCount: vendorLedgerDataResponse[i].activeTripCount,
            lastUpdated: getLedgerDisplayDateTime(vendorLedgerDataResponse[i].updatedAt),
            vendorBalance: vendorLedgerDataResponse[i].totalRemainingAmount,
            avatarString: getAvatarStringFromName(vendorLedgerDataResponse[i].name)
          })
        }
      }
    } else {
      console.error("Error while fetching vendor ledger data : " + response.status.code + " : " + response.status.message)
    }
    logger.log("HomeActionCreator", "In populateVendorLedgerData after data loading : " + vendorLedgerData.length)
  }
  return { type: constants.GET_VENDOR_LEDGER_DATA, payload: { maxPage: response && response.response && response.response.maxPage ? response.response.maxPage : null, merge: merge, vendorLedgerData: vendorLedgerData, totalRemainingAmountDweb: response.response.totalRemainingAmount, activeTripCountDweb: response.response.activeTripCount } };
}

export const updateVendorName = (vendorName) => {
  return { type: constants.UPDATE_VENDOR_NAME, payload: vendorName };
}

/**
  * Trip Ledger Screen
  * @param {*} data - API Request data
  * @param {*} onSuccess
  * @param {*} onError
  */
export const getTripLedgerData = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/fetchtripstransaction",
    data,
    success: (response) => populateTripLedgerData(response, data && data.merge ? data.merge : false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getTripLedgerDataV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/trip/filters/apply",
    data,
    success: (response) => populateTripLedgerDataV2(response, data && data.merge ? data.merge : false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getShopKhataData = (data, onSuccess, onError) => {
  let query = ""
  if (data) {
    if (data.searchText) {
      query += `?search=${data.searchText}`
    }
    if (data.pageSize) {
      query += query ? `&&pageSize=${data.pageSize}` : `?pageSize=${data.pageSize}`
    }
    if (data.pageNo) {
      query += query ? `&&pageNo=${data.pageNo}` : `?pageNo=${data.pageNo}`
    }
  }
  return ({
    type: constants.API,
    payload: {
      method: "GET",
      url:
        `/khata/shops${query ? query : ""}`,
      data,
      success: (response) => populateShopKhataData(response, data && data.merge ? data.merge : false),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    },
  });
}
export const updateTripPagination = (data) => {
  return { type: constants.UPDATE_TRIPS_PAGE_NO, payload: { count: data } };
}

const populateTripLedgerData = (response, merge) => {
  var tripLedgerData = [];
  if (response.status && response.status.code && response.status.code == 200 && response.response)
    tripLedgerData = populateTripScreenData(response.response.tripLogs)
  else
    console.error("Error while fetching trip ledger data : " + response.status.code + " : " + response.status.message)
  return { type: constants.GET_TRIP_LEDGER_DATA, payload: { tripLedgerData, totalCount: response.response.totalCount, merge: merge } };
}

const populateTripLedgerDataV2 = (response, merge) => {
  var tripLedgerData = [];
  if (response.status && response.status.code && response.status.code == 200 && response.response)
    tripLedgerData = populateTripScreenData(response.response.tripLogs)
  else
    console.error("Error while fetching trip ledger data : " + response.status.code + " : " + response.status.message)
  return { type: constants.GET_TRIP_LEDGER_DATA_V2, payload: { tripLedgerData, totalCount: response.response.totalCount, merge: merge } };
}

const populateShopKhataData = (response, merge) => {
  var shopsData = [];
  if (response.status && response.status.code && response.status.code == 200 && response.response)
    shopsData = response.response;
  else
    console.error("Error while fetching trip ledger data : " + response.status.code + " : " + response.status.message)
  return { type: constants.GET_SHOP_KHATA_DATA, payload: { shopsData: shopsData, merge: merge } };
}

/**
 * Single Party Ledger screen
 * @param {*} data - API Request data
 * @param {*} onSuccess
 * @param {*} onError
 */
export const getSinglePartyLedgerData = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/fetchtripstransaction",
    data,
    success: (response) => populateSinglePartyLedgerData(response, data && data.merge ? data.merge : false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getSinglePartyLedgerDataV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/trip/filters/apply",
    data,
    success: (response) => populateSinglePartyLedgerDataV2(response, data && data.merge ? data.merge : false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getSinglePartyPDFReport = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/fetchtripstransaction/customer/all/pdf",
    data,
    success: (response) => populateSinglePartyPDFReport(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const populateSinglePartyLedgerData = (response, merge) => {
  var payloadData = {}
  if (merge) {
    payloadData.merge = true
  }
  if (response.status && response.status.code && response.status.code == 200 && response.response) {
    logger.log("HomeActionCreator", response.response.totalNotYetDueAmount);
    payloadData['partyName'] = response.response.customerName ? response.response.customerName : ''
    payloadData['partyMobile'] = response.response.customerContactNumber ? response.response.customerContactNumber : ''
    payloadData['singlePartyLedgerData'] = populateTripScreenData(response.response.tripLogs)

    payloadData['partyBalance'] = parseInt(response.response.totalNotYetDueAmount);
    payloadData['partyBalance'] += parseInt(response.response.totalDueAmount);

    payloadData['dueAmount'] = parseInt(response.response.totalDueAmount);
    payloadData['activeTripCount'] = response.response.activeTripsCount;
    payloadData['maxPage'] = response.response.maxPage;
  } else
    console.error("Error while fetching party ledger data : " + response.status.code + " : " + response.status.message)
  return { type: constants.GET_SINGLE_PARTY_LEDGER_DATA, payload: payloadData };
}
const populateSinglePartyLedgerDataV2 = (response, merge) => {
  var payloadData = {}
  if (merge) {
    payloadData.merge = true
  }
  if (response.status && response.status.code && response.status.code == 200 && response.response) {
    logger.log("HomeActionCreator", response.response.totalNotYetDueAmount);
    payloadData['partyName'] = response.response.customerName ? response.response.customerName : ''
    payloadData['partyMobile'] = response.response.customerContactNumber ? response.response.customerContactNumber : ''
    payloadData['singlePartyLedgerData'] = populateTripScreenData(response.response.tripLogs);
    let openingLogs = []
    if(response.response.openingBalance){
        let bal = response.response.openingBalance;
        openingLogs.push({
          ...bal,
          openingBalanceId:bal.id,
          amount:bal.remainingAmount,
          status:"POD_SUBMITTED",
          startTime:bal.date,
          id:'openingBalance'
        })
    }
    /*if (merge) {
      payloadData['singlePartyLedgerData'] = populateTripScreenData(response.response.tripLogs)
    }else{
      let openingLogs = []
      if(response.response.openingBalance){
          let bal = response.response.openingBalance;
          openingLogs.push({
            ...bal,
            openingBalanceId:bal.id,
            amount:bal.remainingAmount,
            status:"POD_SUBMITTED",
            startTime:bal.date,
            id:'openingBalance'
          })
      }
      if(response.response.tripLogs && response.response.tripLogs.length>0){
        if(openingLogs && openingLogs.length>0){
          payloadData['singlePartyLedgerData'] = [...populateTripScreenData(response.response.tripLogs),...openingLogs]
        }else{
          payloadData['singlePartyLedgerData'] = populateTripScreenData(response.response.tripLogs)
        }
      }else{
        if(openingLogs && openingLogs.length>0)
          payloadData['singlePartyLedgerData'] = openingLogs
        else
          payloadData['singlePartyLedgerData'] = populateTripScreenData(response.response.tripLogs)
      }
    }*/
    payloadData['partyBalance'] = response.response.totalPartyBalance;
    payloadData['openingLogs'] = openingLogs;
    payloadData['dueAmount'] = parseInt(response.response.totalDueAmount);
    payloadData['activeTripCount'] = response.response.activeTripCount;
    payloadData['maxPage'] = response.response.maxPage;
  } else{
    console.error("Error while fetching party ledger data : " + response.status.code + " : " + response.status.message)
  }
  return { type: constants.GET_SINGLE_PARTY_LEDGER_DATA, payload: payloadData };
}
const populateSinglePartyPDFReport = (response) => {
  var payloadData = {}
  if (response.status && response.status.code && response.status.code == 200 && response.response) {
    payloadData['singlePartyPDFReportData'] = response.response
  } else
    console.error("Error while fetching party ledger data : " + response.status.code + " : " + response.status.message)
  return { type: constants.GET_SINGLE_PARTY_PDF_REPORT, payload: payloadData };
}

/**
 * Single Supplier Ledger screen
 * @param {*} data - API Request data
 * @param {*} onSuccess
 * @param {*} onError
 */
export const getSingleVendorLedgerData = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/fetch_vendor_transactions",
    data,
    success: (response) => populateSingleVendorLedgerData(response, data && data.merge ? data.merge : false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getSingleVendorLedgerDataV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/trip/filters/apply",
    data,
    success: (response) => populateSingleVendorLedgerDataV2(response, data && data.merge ? data.merge : false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getSingleVendorPDFReport = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/get_vendor_transactions_pdf",
    data,
    success: (response) => populateSingleVendorPDFReport(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const getAllVendors = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/vendor/all",
    data,
    success: (response) => populateAllVendors(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
const populateAllVendors = (response) => {
  var payloadData = {}
  if (response.status && response.status.code && response.status.code == 200 && response.response) {
    payloadData['allVendors'] = response.response;
  } else {
    console.error("Error while fetching all vendors : " + response.status.code + " : " + response.status.message)
  }
  return { type: constants.GET_ALL_VENDORS_DATA, payload: payloadData };
}
export const getAllPnlMonths = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/pnl_months",
    data,
    success: (response) => populateAllPnlMonths(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
const populateAllPnlMonths = (response) => {
  var payloadData = {}
  if (response.status && response.status.code && response.status.code == 200 && response.response && response.response.months) {
    payloadData['pnlMonths'] = response.response.months;
  } else {
    console.error("Error while fetching all pnlMonths : " + response.status.code + " : " + response.status.message)
  }
  return { type: constants.GET_PNL_MONTHS, payload: payloadData };
}
export const getPNLPerMonth = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/pnl_report_pdf/" + data,
    data,
    success: (response) => populatePNLPerMonth(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
const populatePNLPerMonth = (response) => {
  var payloadData = {}
  if (response.status && response.status.code && response.status.code == 200 && response.response) {
    payloadData['monthlyPNLWise'] = response.response;
  } else {
    console.error("Error while fetching all GET_PNL_MONTHLY_WISE : " + response.status.code + " : " + response.status.message)
  }
  return { type: constants.GET_PNL_MONTHLY_WISE, payload: payloadData };
}
export const getAllParties = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/customers",
    data,
    success: (response) => populateAllParties(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
const populateAllParties = (response) => {
  var payloadData = {}
  if (response.status && response.status.code && response.status.code == 200 && response.customers) {
    payloadData['allParties'] = response.customers;
  } else {
    console.error("Error while fetching all vendors : " + response.status.code + " : " + response.status.message)
  }
  return { type: constants.GET_ALL_PARTIES_DATA, payload: payloadData };
}
const populateSingleVendorLedgerData = (response, merge) => {
  var payloadData = {}
  if (response.status && response.status.code && response.status.code == 200 && response.response) {
    payloadData['singleVendorLedgerData'] = populateTripScreenData(response.response.tripRecords)
    payloadData['totalBalance'] = response.response.totalBalance;
    payloadData['dueAmount'] = response.response.dueBalance;
    payloadData['activeTripCount'] = response.response.activeTripsCount;
    payloadData['vendorName'] = response.response.vendorName;
    payloadData['totalCount'] = response.response.totalCount;
    payloadData['vendorNumber'] = response.response.vendorNumber;
    payloadData['merge'] = merge;
    payloadData['singleVendorTripsMaxPage'] = response.response.maxPage;
  } else
    console.error("Error while fetching vendor ledger data : " + response.status.code + " : " + response.status.message)
  return { type: constants.GET_SINGLE_VENDOR_LEDGER_DATA, payload: payloadData };
}
const populateSingleVendorLedgerDataV2 = (response, merge) => {
  var payloadData = {}
  if (response.status && response.status.code && response.status.code == 200 && response.response) {
    payloadData['singleVendorLedgerData'] = populateTripScreenData(response.response.tripLogs)
    payloadData['totalBalance'] = response.response.totalSupplierBalance;
    payloadData['dueAmount'] = response.response.dueBalance;
    payloadData['activeTripCount'] = response.response.activeTripsCount;
    payloadData['vendorName'] = response.response.vendorName;
    payloadData['totalCount'] = response.response.totalCount;
    payloadData['vendorNumber'] = response.response.vendorNumber;
    payloadData['merge'] = merge;
    payloadData['singleVendorTripsMaxPage'] = response.response.maxPage;
  } else
    console.error("Error while fetching vendor ledger data : " + response.status.code + " : " + response.status.message)
  return { type: constants.GET_SINGLE_VENDOR_LEDGER_DATA, payload: payloadData };
}
const populateSingleVendorPDFReport = (response) => {
  var payloadData = {}
  if (response.status && response.status.code && response.status.code == 200 && response.response) {
    payloadData['singleVendorPDFReport'] = response.response
  } else
    console.error("Error while fetching party ledger data : " + response.status.code + " : " + response.status.message)
  return { type: constants.GET_SINGLE_VENDOR_PDF_REPORT, payload: payloadData };
}
/**
 * Common method to populate Trip data in screen required format from response
 * @param tripLogs
 */
const populateTripScreenData = (tripLogs) => {
  var trips = []
  if (tripLogs && tripLogs.length > 0) {
    for (var i = 0; i < tripLogs.length; i++) {
      var vehicleNumber = tripLogs[i].vehicleNumber ? tripLogs[i].vehicleNumber : (tripLogs[i].vehicle ? tripLogs[i].vehicle.vehicleNumber : '')
      var vehicleNumberPrefix = vehicleNumber.substring(0, vehicleNumber.length - 4)
      var vehicleNumberSuffix = vehicleNumber.substring(vehicleNumber.length - 4, vehicleNumber.length)
      var customerName = tripLogs[i].customerName ? tripLogs[i].customerName : (tripLogs[i].customer ? tripLogs[i].customer.customerName : '')
      var vehicleNumArrayValue = getVehicleNumberValuesDWeb(vehicleNumber);
      trips.push({
        ...tripLogs[i],
        id: tripLogs[i].id ? tripLogs[i].id : tripLogs[i].tripId,
        customerName: customerName,
        vehicleNumber: vehicleNumber,
        startLocation: tripLogs[i].startLocation,
        destinationLocation: tripLogs[i].destinationLocation,
        startDest: tripLogs[i].startLocation && tripLogs[i].destinationLocation ? tripLogs[i].startLocation + tripLogs[i].destinationLocation : tripLogs[i].tripId,
        startTime: tripLogs[i].startDate,
        vehicleNumArrayDweb: vehicleNumArrayValue,
        startDate: getDateInStringDDMMMYYYY(tripLogs[i].startDate),
        startDateTable: tripLogs[i].startDate,
        completedDate: tripLogs[i].completedDate ? getDateInStringDDMMMYYYY(tripLogs[i].completedDate) : '',
        status: tripLogs[i].status,
        amount: tripLogs[i].totalRemainingAmount,
        vehicleNumberPrefix: vehicleNumberPrefix,
        vehicleNumberSuffix: vehicleNumberSuffix
      });
    }
  }

  return trips;
}

// Fetching locations for Profile.
export const getAllLocationsForProfile = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "https://tpbook.s3.ap-south-1.amazonaws.com/resources/cities.txt",
    data: null,
    success: (response) => populateAllLocationsForProfile(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const getAllLocationsForGST = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/elr/gst_states",
    data: null,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const getAllLocationsForStates = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/elr/gst_states",
    data: null,
    success: (response) => populateAllLocationsForStates(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

const populateAllLocationsForProfile = (locationListResponse) => {
  let city = [];
  let state = [];
  let locationList = [];

  locationListResponse.map((location) => {
    city.push(location.city);
    //state.push(location.state);
  })

  city = city.filter((value, index) => city.indexOf(value) === index);
  //state = state.filter((value, index) => state.indexOf(value) === index);

  locationList.push(city.sort());
  //locationList.push(state.sort());
  return { type: constants.GET_ALL_LOCATIONS_FOR_PROFILE, payload: locationList }
}
const populateAllLocationsForStates = (response) => {
  let state = [];
  if(response.response){
    response.response.map((location) => {
      state.push(location.State);
    })
    state.sort();
  }
  return { type: constants.GET_ALL_LOCATIONS_STATES, payload: state }
}

/**
 * Location data used for populating all locations when creating trip
 * @param {*} onSuccess
 * @param {*} onError
 */
export const getAllLocations = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "https://tpbook.s3.ap-south-1.amazonaws.com/resources/cities.txt",
    data: null,
    success: (response) => populateAllLocations(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const getSuggestedOrginLocations = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/location/suggested?locationType=origin${data && data.vehicle ? `&vehicle=${data.vehicle}` : ''}`,
    data: null,
    success: (response) => populateAllOrginLocations(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
const populateAllOrginLocations = (response) => {
  let locationListResponse = []
  if (response && response.response) {
    locationListResponse = response.response.map((location) => {
      return { 'name': location.name, 'district': location.district, 'state': location.state, 'mapper': "Suggested Locations" };
    })
  }
  return { type: constants.GET_ALL_SUGGESTED_ORIGIN_LOCATIONS, payload: locationListResponse };
}
export const getSuggestedDestinationLocations = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/location/suggested?locationType=destination${data && data.vehicle ? `&vehicle=${data.vehicle}` : ''}`,
    data: null,
    success: (response) => populateAllDestinationLocations(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
const populateAllDestinationLocations = (response) => {
  let locationListResponse = []
  if (response && response.response) {
    locationListResponse = response.response.map((location) => {
      return { 'name': location.name, 'district': location.district, 'state': location.state, 'mapper': "Suggested Locations" };
    })
  }
  return { type: constants.GET_ALL_SUGGESTED_DESTINATION_LOCATIONS, payload: locationListResponse };
}
const populateAllLocations = (locationListResponse) => {
  locationListResponse = locationListResponse.map((location) => {
    return { 'name': location.city, 'district': location.district, 'state': location.state, 'mapper': "All Locations" };
  })
  return { type: constants.GET_ALL_LOCATIONS, payload: locationListResponse };
}

export const getDriverLedger = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/driver_ledger",
    data,
    success: (response) => populateAllDriver(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getDriverLedgerV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/driver_ledger-v2",
    data,
    success: (response) => populateAllDriver(response, data && data.merge ? data.merge : false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const populateAllDriver = (response, merge) => {
  let driverLedgerDataResponse;
  let totalBalance = 0;
  if (response.status && response.status.code && response.status.code == 200) {
    if (response.response) {
      driverLedgerDataResponse = response.response.driverItems

      if (driverLedgerDataResponse.length > 0)
        for (var i = 0; i < driverLedgerDataResponse.length; i++) {
          driverLedgerDataResponse[i].avatarString = getAvatarStringFromName(driverLedgerDataResponse[i].name);
          driverLedgerDataResponse[i].lastUpdatedString = getLedgerDisplayDateTime((driverLedgerDataResponse[i].lastUpdated).toString());
          totalBalance += driverLedgerDataResponse[i].driverBalance
        }
      // driverLedgerDataResponse.balance = totalBalance;
    } else {
      logger.log("Error while fetching driver ledger data : " + response.status.code + " : " + response.status.message)
    }
    logger.log("HomeActionCreator", "In populateDriverLedgerData after data loading : " + driverLedgerDataResponse)
  }
  return {
    type: constants.FETCH_ALL_DRIVERS, payload: {
      maxPage: response && response.response && response.response.maxPage ? response.response.maxPage : null,
      merge: merge, driverLedgerDataResponse, totalCount: response.response.totalCount, balance: totalBalance
    }
  }
}

export const GetPaymentConfig = (onSuccess, onError, data = { filteredKeys: ["customer_payment_reminder_config"] }) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/configs/filtered",
    data,
    success: (response) => processPaymentConfig(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

const processPaymentConfig = (data) => {
  let response = data && data.response && data.response.customer_payment_reminder_config ? data.response.customer_payment_reminder_config : {};
  return { type: constants.GET_PAYMENT_CONFIG, payloadData: response }
}

export const getSparklineTotalBalances = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/sparkline",
    success: (response) => processGetTotalBalances(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
})

const processGetTotalBalances = (data) => {
  let payloadData = data && data.response ? data.response : {}
  return { type: constants.GET_SPARKLINE_DATA, payload: payloadData }
}
const processUselessData = (data) => {
  return { type: null, payload: null }
}